import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { getGetSingleConditionValue } from '../../../_helpers/singleConditionValue'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import { DEFAULT_REPLY_QUESTION_TYPES } from '../../../../../../utils/interpolations/replies'
import { useInterpolations } from '../../../../../../utils/interpolations/interpolations'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import InputWithInterpolations from '../../../../../../packages/kiti-editor/components/input/InputWithInterpolations'
import Modal from '../../../../../../components/structure/Modal'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import Textarea from '../../../../../../components/form/Textarea'
import TemplateSelect from '../../../../../../containers/integrations/ChatPro/TemplateSelect'
import { useIntegration } from '../../../_load/IntegrationLoader'
import validate from './_helpers/validate'

const isDynamicAutomationValue = value => typeof value === 'string' && /\{\{/.test(value)

/** Chaves do mapa `variables` ordenadas posicionalmente (1, 2, 3…). */
const orderedVariableKeys = labels => Object.keys(labels || {}).sort((a, b) => Number(a) - Number(b))

const ChatProSendWhatsAppSentence = () => {
  const { t } = useTranslation('triggers')
  const [open, setOpen] = React.useState()
  const { form, setErrors } = useFormState()

  const integration = useIntegration()

  const checklistId = getGetSingleConditionValue(form.conditions, 'checklist_id')
  const interpolationsNumber = useInterpolations(form.entity, checklistId, undefined, {
    replyQuestionTypes: ['text']
  }).filter(item => {
    if (item.group === 'Respostas') return true
    if (item.group === 'Campos adicionais') return item.type === 'text'
    return false
  })
  const variableReplyQuestionTypes = DEFAULT_REPLY_QUESTION_TYPES.filter(
    type => !['block', 'sign', 'gallery'].includes(type)
  )
  const interpolationsVariables = useInterpolations(form.entity, checklistId, undefined, {
    replyQuestionTypes: variableReplyQuestionTypes
  })

  const template = form.payload?.template
  const variableKeys = orderedVariableKeys(template?.labels)

  const numberRaw = form.payload?.number
  const numberSentenceLabel = isDynamicAutomationValue(numberRaw) ? t('chatPro.dynamicNumber') : numberRaw || '_______'

  const handleSubmit = () => {
    const isValid = validate(form, variableKeys, setErrors)
    if (isValid) setOpen(false)
  }

  return (
    <>
      <Text size="h2">para o número</Text>

      <EditableSentence label={numberSentenceLabel} truncate={20} onClick={() => setOpen(true)} field="payload" />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Col width="100%">
          <FormItem
            label="Número*"
            path={['payload', 'number']}
            Input={InputWithInterpolations}
            interpolations={interpolationsNumber}
            singleLine
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem
            label="Template*"
            path={['payload', 'template']}
            Input={props => <TemplateSelect filter={{ integrationId: integration?.id }} {...props} />}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem label="Mensagem*" path={['payload', 'template', 'bodyText']} Input={Textarea} disabled={true} />
        </Col>

        {variableKeys.map(key => {
          return (
            <Col width="100%" key={key}>
              <Separator weight={4} />
              <FormItem
                label={`{{${key}}}*`}
                path={['payload', 'template', 'variables', key]}
                Input={InputWithInterpolations}
                interpolations={interpolationsVariables}
                singleLine
              />
            </Col>
          )
        })}

        <SubmitBar onClick={handleSubmit} />
      </Modal>
    </>
  )
}

export default ChatProSendWhatsAppSentence
